module.exports = __webpack_public_path__ + "static/media/whatsapp_sm.78ecc62e1df6740e1d8021ea1375eafe.svg";